import React, { useState } from 'react';
import Gallery01 from '../assets/images/Gallery01.png';
import Gallery02 from '../assets/images/Gallery02.png';
import Gallery03 from '../assets/images/Gallery03.png';
import Logo from '../assets/Logo/mainlogo.png';

export const GalleryPage = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const imgUrls = [
    Gallery01,
    Gallery02,
    Gallery01,
    Gallery03,
    Gallery01,
    Gallery01,
    Gallery01,
    Gallery01,
    Gallery01,
    Gallery01,
    Gallery01,
    Gallery01
  ];

  const openModal = (index) => {
    setCurrentIndex(index);
  };

  const closeModal = () => {
    setCurrentIndex(null);
  };

  const findPrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const findNext = () => {
    if (currentIndex + 1 < imgUrls.length) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        {imgUrls.map((src, index) => (
          <div key={index} onClick={() => openModal(index)}>
            <img src={src} alt={`Gallery Image ${index + 1}`} />
          </div>
        ))}
      </div>
      {currentIndex !== null && (
        <GalleryModal
          closeModal={closeModal}
          findPrev={findPrev}
          findNext={findNext}
          hasPrev={currentIndex > 0}
          hasNext={currentIndex + 1 < imgUrls.length}
          src={imgUrls[currentIndex]}
        />
      )}
    </div>
  );
};

const GalleryModal = ({ closeModal, findPrev, findNext, hasPrev, hasNext, src }) => {
  if (!src) return null;

  const handleKeyDown = (e) => {
    if (e.keyCode === 27) closeModal();
    if (e.keyCode === 37 && hasPrev) findPrev();
    if (e.keyCode === 39 && hasNext) findNext();
  };

  return (
    <div>
      
      <div className="modal-overlay" onClick={closeModal}></div>
      <div className="modal">
        <div className="modal-body">
          <span className="modal-close" onClick={closeModal} onKeyDown={handleKeyDown}>
            &times;
          </span>
          {hasPrev && (
            <span className="modal-prev" onClick={findPrev} onKeyDown={handleKeyDown}>
              &lsaquo;
            </span>
          )}
          {hasNext && (
            <span className="modal-next" onClick={findNext} onKeyDown={handleKeyDown}>
              &rsaquo;
            </span>
          )}
          <img src={src} alt="Gallery Image" />
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;
